import { Component } from '@angular/core';
import { ActivatedRoute, NavigationStart, Router } from '@angular/router';
import { AuthenticationService, LanguageService } from './core/services';
import { IUser, UserType } from './core/interfaces';
import { isBusinessShellRoute } from '@core/configs/route-paths';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  user: IUser;
  private activeUserType: UserType;
  private currentUrl = '';

  showHead: boolean = false;
  showFooter: boolean = true;
  ngOnInit() {
  }

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private authenticationService: AuthenticationService,
    private languageService: LanguageService
  ) {
    this.languageService.init();

    this.authenticationService.currentUser.subscribe(x => {
      this.user = x;
      this.languageService.syncWithUserLanguage(x?.culture);
    });
    this.authenticationService.userActiveType$.subscribe(au => {
      this.activeUserType = au;
      this.updateShellVisibility(this.currentUrl || this.router.url);
    });

    router.events.forEach((event) => {
      if (event instanceof NavigationStart) {
        this.updateShellVisibility(event.url);
      }
    });
  }

  private updateShellVisibility(url: string): void {
    this.currentUrl = url || '';

    const hideShell = isBusinessShellRoute(this.currentUrl) || /\/embed(?:-preview)?(?:[/?#]|$)/.test(this.currentUrl);

    this.showHead = !hideShell;
    this.showFooter = !hideShell && this.activeUserType !== UserType.Business;
  }
}
